import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { type GameStates } from '@/hooks';
import { YatSprite } from '@/components/YatSprite';

export const Wrapper = styled(motion.div)<{ $gameState: GameStates; $compact?: boolean }>`
    position: relative;
    padding: 1px;
    border-radius: 100px;
    display: flex;
    transition: background 0.3s 0.7s ease;

    ${({ $gameState }) => {
        if ($gameState === 'loading') {
            return css`
                background: linear-gradient(180deg, rgba(0, 255, 133, 0.34) 0%, rgba(18, 87, 21, 0.31) 100%);
            `;
        }
        if ($gameState === 'open' || $gameState === 'playing') {
            return css`
                background: linear-gradient(180deg, #00ff85 0%, #00c708 100%);
            `;
        }
        if ($gameState === 'upcoming') {
            return css`
                background: linear-gradient(180deg, #ffe000 0%, #ef6c01 100%);
            `;
        }
        if ($gameState === 'closed' || $gameState === 'ended') {
            return css`
                background: linear-gradient(180deg, #ff0000 0%, #c75400 100%);
            `;
        }
    }}

    min-height: 28px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 2px;
        min-height: 51px;

        ${({ $compact }) =>
            $compact &&
            css`
                min-height: 41px;
            `}
    }
`;

export const Inside = styled.div<{ $gameState: GameStates; $compact?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
    border-radius: 100px;
    transition: background 0.3s 0.7s ease;
    width: 100%;
    padding: 6px 12px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 8px 25px;
    }

    ${({ $gameState }) => {
        if ($gameState === 'loading') {
            return css`
                background: #071618;
            `;
        }
        if ($gameState === 'open' || $gameState === 'playing') {
            return css`
                background: #132d2b;
            `;
        }
        if ($gameState === 'upcoming') {
            return css`
                background: #2f2020;
            `;
        }

        if ($gameState === 'closed' || $gameState === 'ended') {
            return css`
                background: #2f1120;
            `;
        }
    }}
`;

export const Icon = styled(YatSprite)`
    font-size: 18px;
    position: relative;
    display: none;
    flex-shrink: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 20px;
        top: 1px;
        display: block;
    }
`;

export const Text = styled.div`
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: -0.48px;
    white-space: nowrap;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;

export const Time = styled.div`
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.48px;

    font-variant-numeric: tabular-nums;
    white-space: nowrap;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;
